import React from 'react'

const FloorManagement = () => {
    return (
        <div>
            Floor Management
        </div>
    )
}

export default FloorManagement
